import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { BudgetTick, Count, Progress, Tick } from './atoms';

const template = styled.div`
  ${({ displayState }) => css`
    width: 100%;
    background: #C7EFDA;
    height:  ${displayState?.height ?? '16px'};
    border: 1px solid #A5E5C4;
    border-radius: 24px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Progress,
      name: 'Progress2',
      displayValue: ({ }) => '',
      displayState: ({ budget, currentSpent, spent }) => {
        const max = budget > (currentSpent + spent) ? budget : (currentSpent + spent)
        return {
          progress: ((currentSpent + spent) / max) * 100,
          color: (currentSpent + spent) > budget ? '#FE6363' : '#61D197'
        }
      }
    },
    {
      component: Progress,
      name: 'Progress',
      displayValue: ({ }) => '',
      displayState: ({ budget, spent, currentSpent }) => {
        const max = (currentSpent + spent) > budget ? (currentSpent + spent) : budget;
        return {
          progress: (spent / max) * 100,
          color: spent > budget ? '#981313' : '#1AAA60'
        }
      }
    },
    {
      component: BudgetTick,
      name: 'BudgetTick',
      displayValue: ({ }) => '',
      renderIf: ({ budget, currentSpent, spent }) => (currentSpent + spent) > budget,
      displayState: ({ budget, currentSpent, spent }) => {
        return { progress: (budget / (currentSpent + spent)) * 100 }
      }
    },
    {
      component: Count,
      name: 'ZeroCount',
      displayValue: ({ }) => '0',
      displayState: ({ }) => ({ progress: 0, top: 36 })
    },
    {
      component: Tick,
      name: 'ZeroTick',
      displayValue: ({ }) => '',
      displayState: ({ }) => ({ progress: 0 })
    },
    {
      component: Count,
      name: 'MaxCount',
      displayValue: ({ budget, currentSpent, spent }) => {
        const max = (currentSpent + spent) > budget ? (currentSpent + spent) : budget;
        return max.toString()
      },
      displayState: ({ }) => ({ progress: 100, top: 36 })
    },
    {
      component: Tick,
      name: 'MaxTick',
      displayValue: ({ }) => '',
      displayState: ({ }) => ({ progress: 100 })
    },
    {
      component: Count,
      name: 'SpentCount',
      renderIf: ({ spent }) => spent,
      displayValue: ({ spent }) => spent.toString(),
      displayState: ({ currentSpent, spent, budget }) => {
        const max = (currentSpent + spent) > budget ? (currentSpent + spent) : budget;
        return { progress: (spent / max) * 100, moveLeft: budget > spent }
      }
    },
    {
      component: Tick,
      name: 'SpentTick',
      displayValue: ({ }) => '',
      displayState: ({ currentSpent, spent, budget }) => {
        const max = (currentSpent + spent) > budget ? (currentSpent + spent) : budget;
        return { progress: (spent / max) * 100 }
      }
    },
    {
      component: Count,
      name: 'BudgetCount',
      displayValue: ({ budget }) => budget.toString(),
      renderIf: ({ budget, currentSpent, spent }) => (currentSpent + spent) > budget,
      displayState: ({ budget, currentSpent, spent }) => {
        return { progress: (budget / (currentSpent + spent)) * 100, moveLeft: spent > budget }
      }
    },
    {
      component: Tick,
      name: 'BudgetSmallTick',
      displayValue: ({ }) => '',
      renderIf: ({ budget, currentSpent, spent }) => (currentSpent + spent) > budget,
      displayState: ({ budget, currentSpent, spent }) => {
        return { progress: (budget / (currentSpent + spent)) * 100 }
      }
    },
  ],
})